import httpService from '@/core/http-service'

const mixin = {
  methods: {
    mergeCarts() {
      this.makeSelection('merge')
    },
    replaceCurrentCart() {
      this.makeSelection('replace')
    },
    useSavedCart() {
      this.makeSelection('useSaved')
    },
    closeModal() {
      this.makeSelection('merge')
    },
    makeSelection(action) {
      httpService.post('cart/merge', { action })
        .then(({ data }) => {
          window.location.replace(data.url)
        })
    }
  }
}

export default mixin
